module.exports = {
  backToMain: '返回主画面',
  print: '打印',
  savePDF: '另存为PDF',
  saveWord: '另存WORD',
  saveExcel: '另存EXCEL',
  email: '邮件',
  fax: '传真',
  company: '公司名称',
  emailAddress: '邮件地址',
  cc: '抄送',
  title: '邮件标题',
  content: '邮件内容',
  localAgent: '本地代理',
  destinationAgent: '起/目港代理',
  designationAgent: '指定货代理',
  customer: '客户',
  bookingAgent: '订舱代理',
  motorcade: '车队',
  warehouse: '仓库',
  send: '发送',
  cancel: '取消',
  tel: '电话',
  ok: '确定',
  faxCode: '区号',
  faxNo: '传真号码',
  faxExt: '分机号',
  BlAddress: '对单地址',
  ShippingCmp: '船司',
  NominatedAgent: '指定货代理',
  PortAgency: '起/目的港代理',
  InvokeLocalMailClient: '调用本地邮箱'
}
